<div class="reply-dialog" [class.reply-all]="model.replyAll" [class.disabled]="inProgress">
  <div class="to-input" *ngIf="model?.to?.length > 0">
    <div class="contact" *ngFor="let contact of model.to">{{ contact }}</div>
  </div>
  <div class="cc-input" *ngIf="model.replyAll && model?.cc?.length > 0">
    <div class="contact" *ngFor="let contact of model.cc">{{ contact }}</div>
  </div>

  <div class="textarea" #textarea (input)="updateBody($event)" (keydown)="textareaKeyDown($event)" contenteditable="true"></div>
  <div class="buttons">
    <button class="btn" (click)="onClose()">Close</button>
    <!--<button class="btn primary" (click)="onProceed()" [title]="(shortcutAccelerator | titlecase) + '+Enter'">Send</button>!-->
  </div>
</div>
